import routes from '@/common/routes/index.js';

export const tabPaths = {
  'monitoring-objects': routes.netProtectionV2Monitoring,
  'protected-profiles': routes.netProtectionV2Protected,
};

export const tabs = [
  {
    tab: 'monitoring-objects',
    title: 'Monitoring objects',
  },
  {
    tab: 'protected-profiles',
    title: 'Protected profiles',
  },
];

export const queryParamsInitial = {
  activeTab: tabs[0].tab,
};
